import React from "react";
import { isEmpty } from "lodash";
import { BVQaAttributeRow } from "./bv-qa-attribute-row";
import { brandVerifiedAttributeStatus } from "../attributes/lib/constants";

export const BVQaAttributeSubgroups = ({
    subGroups,
    roleLabels,
    columnWidths,
    attributeValues,
    gridTemplate,
    onUpdateAttribute,
    viewAllAttributes,
    onAttrList,
    refreshAttributeGroups,
    isCompleted,
}) => {
    return (
        <>
            {subGroups
                .filter(({ attributes }) =>
                    viewAllAttributes
                        ? viewAllAttributes
                        : !attributes.every((attribute) => attribute.additionalInfo?.approvalStatus === brandVerifiedAttributeStatus.AutoAccepted)
                )
                .map(({ groupLabel, groupName, ...subGroupParams }) => {
                    return (
                        <div key={groupName}>
                            <h3>{groupLabel}</h3>

                            {!isEmpty(subGroupParams.attributes) &&
                                subGroupParams.attributes.map((attr) => {
                                    return (
                                        <BVQaAttributeRow
                                            key={attr.key}
                                            viewAllAttributes={viewAllAttributes}
                                            attr={attr}
                                            roleLabels={roleLabels}
                                            attributeValues={attributeValues}
                                            gridTemplate={gridTemplate}
                                            onUpdateAttribute={onUpdateAttribute}
                                            onAttrList={onAttrList}
                                            refreshAttributeGroups={refreshAttributeGroups}
                                            isCompleted={isCompleted}
                                        />
                                    );
                                })}
                            {subGroupParams.subGroups.map(({ attributes: innerAttributes, groupName: attrGroup }) => {
                                return (
                                    <div
                                        key={`${groupName}_${attrGroup}`}
                                        className="m-t-16"
                                    >
                                        <BVQaAttributeSubgroups
                                            columnWidths={columnWidths}
                                            attributes={innerAttributes}
                                            viewAllAttributes={viewAllAttributes}
                                            subGroups={[]}
                                            onUpdateAttribute={onUpdateAttribute}
                                            onAttrList={onAttrList}
                                            refreshAttributeGroups={refreshAttributeGroups}
                                            isCompleted={isCompleted}
                                        />
                                    </div>
                                );
                            })}
                        </div>
                    );
                })}
        </>
    );
};
